import { ArrowLeft, GitMerge } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';

interface MergePageHeaderProps {
  currentStep: 'select' | 'preview';
  destinationId: string;
  isLoading: boolean;
  onCancel: () => void;
  onBack: () => void;
  onNext: () => void;
  onMerge: () => void;
}

export const MergePageHeader = ({
  currentStep,
  destinationId,
  isLoading,
  onCancel,
  onBack,
  onNext,
  onMerge,
}: MergePageHeaderProps) => {
  return (
    <div className="bg-white border-b border-gray-200 px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Button
            variant="ghost"
            size="sm"
            onClick={currentStep === 'select' ? onCancel : onBack}
            className="gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            {currentStep === 'select'
              ? 'Back to Coverage List'
              : 'Back to Selection'}
          </Button>
          <Separator orientation="vertical" className="h-6" />
          <div className="flex items-center gap-2">
            <GitMerge className="h-5 w-5 text-gray-600" />
            <h1 className="text-xl font-semibold text-gray-900">
              {currentStep === 'select'
                ? 'Select Coverage to Merge'
                : 'Confirm Merge'}
            </h1>
          </div>
        </div>

        <div className="flex items-center gap-3">
          {currentStep === 'select' ? (
            <>
              <Button variant="outline" onClick={onCancel}>
                Cancel
              </Button>
              <Button
                onClick={onNext}
                disabled={!destinationId}
                className="gap-2"
              >
                Next: Preview Merge
              </Button>
            </>
          ) : (
            <>
              <Button variant="outline" onClick={onBack} disabled={isLoading}>
                Back
              </Button>
              <Button onClick={onMerge} disabled={isLoading} className="gap-2">
                <GitMerge className="h-4 w-4" />
                {isLoading ? 'Merging...' : 'Confirm Merge'}
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
